import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  radius,
  shadow,
  spacing
} from '../../../theme';

export const StyledCardLink = styled.a`
  border-radius: ${radius('lg')};
  color: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: 0.3s;

  &:hover {
    box-shadow: ${shadow('md')};
    background-color: ${color('white')};
    color: inherit;
  }
`;

export const StyledImg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12rem;

  img {
    max-width: 9.875rem;
  }
`;

export const StyledContent = styled.div`
  padding: ${spacing('md')};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs2')};
`;

export const StyledName = styled.p`
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('lg')};
  margin: 0;
`;

export const StyledDesc = styled.p`
  color: ${color('text_subtle')};
  margin: 0;
`;

export const StyledSocial = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing('xs2')};
  margin-top: auto;
  padding-top: ${spacing('xs')};
`;
